// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/SearchOperator.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file Enumerations/SearchOperator.proto.
 */
export const file_Enumerations_SearchOperator: GenFile = /*@__PURE__*/
  fileDesc("CiFFbnVtZXJhdGlvbnMvU2VhcmNoT3BlcmF0b3IucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKkEKDlNlYXJjaE9wZXJhdG9yEhYKElNFQVJDSF9PUEVSQVRPUl9PUhAAEhcKE1NFQVJDSF9PUEVSQVRPUl9BTkQQAUIoqgIlTW9naS5UaW1lVHJhY2tpbmcuQ29tbW9uLkVudW1lcmF0aW9uc2IGcHJvdG8z");

/**
 * Specifies how different text searches should be combined.
 *
 * @generated from enum time_tracking.enumerations.SearchOperator
 */
export enum SearchOperator {
  /**
   * Combine text searches so that any one has to match for the search to be considered successful.
   *
   * @generated from enum value: SEARCH_OPERATOR_OR = 0;
   */
  OR = 0,

  /**
   * Combine text searches so that all of them have to match for the search to be considered successful.
   *
   * @generated from enum value: SEARCH_OPERATOR_AND = 1;
   */
  AND = 1,
}

/**
 * Describes the enum time_tracking.enumerations.SearchOperator.
 */
export const SearchOperatorSchema: GenEnum<SearchOperator> = /*@__PURE__*/
  enumDesc(file_Enumerations_SearchOperator, 0);

